import { render, staticRenderFns } from "./Profiler.vue?vue&type=template&id=1f2ca74a"
import script from "./Profiler.vue?vue&type=script&lang=js"
export * from "./Profiler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn,QSpinnerIos,QScrollArea,QSeparator});
